var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left"},[_c('GenericForm',_vm._b({staticClass:"m-0",on:{"validated":_vm.onValidate,"updated":function($event){_vm.localStyle = $event}}},'GenericForm',_vm.genericFormConfig,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }